/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Můj produkt má vadu.`
};

const da_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Mit produkt er defekt.`
};

const de_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Mein Produkt ist defekt.`
};

const en_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `My product is faulty.`
};

const es_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Mi producto está defectuoso.`
};

const fr_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Mon produit est défectueux.`
};

const hu_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `A termékemnek van egy hibája.`
};

const it_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Il mio prodotto è difettoso.`
};

const nl_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn product is defect.`
};

const pl_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt jest wadliwy.`
};

const pt_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Meu produto está com defeito.`
};

const sv_contact_subjects_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Min produkt är defekt.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_faulty_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_faulty_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_faulty_product", locale)
	if (locale === "cs") return cs_contact_subjects_faulty_product(inputs)
	if (locale === "da") return da_contact_subjects_faulty_product(inputs)
	if (locale === "de") return de_contact_subjects_faulty_product(inputs)
	if (locale === "en") return en_contact_subjects_faulty_product(inputs)
	if (locale === "es") return es_contact_subjects_faulty_product(inputs)
	if (locale === "fr") return fr_contact_subjects_faulty_product(inputs)
	if (locale === "hu") return hu_contact_subjects_faulty_product(inputs)
	if (locale === "it") return it_contact_subjects_faulty_product(inputs)
	if (locale === "nl") return nl_contact_subjects_faulty_product(inputs)
	if (locale === "pl") return pl_contact_subjects_faulty_product(inputs)
	if (locale === "pt") return pt_contact_subjects_faulty_product(inputs)
	return sv_contact_subjects_faulty_product(inputs)
};
export { contact_subjects_faulty_product as "contact.subjects.faulty_product" }